import React, { useMemo } from 'react';
import { useHistory } from '../../../providers/HistoryProvider';
import { TemplateType } from '@neum/frontend-shared/constants/templateData';
import { DocumentActionPromptBanner } from '../common/DocumentActionPromptBanner';
import { ErrorBanner } from '../../common/ErrorBanner';

export const ProcessSingleNoteBanner: React.FC = () => {
    const {
        selectedNoteMetadata,
        template,
        setTemplate,
        processNotes,
    } = useHistory()

    const status = useMemo(() => selectedNoteMetadata?.status, [selectedNoteMetadata?.status])
    
    const noteTitle = useMemo(() => selectedNoteMetadata?.title, [selectedNoteMetadata?.title])

    const title = useMemo(() => {
        if (status === "Updated") {
            return "Process new recordings for this note?";
        } else if (status === "Failed") {
            return "Retry processing this note?";
        } else {
            return "Process recordings for this note?";
        }
    }, [status]);

    const description = useMemo(() => {
        if (status === "Updated") {
            return `Process latest recordings and update ${noteTitle ?? "this note"}.`;
        } else if (status === "Failed") {
            return undefined;
        } else {
            return `Process recordings and generate ${noteTitle ?? "a note"}.`;
        }
    }, [status, noteTitle]);

    const buttonText = useMemo(() => {
        if (status === "Updated") {
            return "Update";
        } else if (status === "Failed") {
            return "Process";
        } else {
            return "Process";
        }
    }, [status]);

    return <div>
        {status === "Failed" && <ErrorBanner className="mb-2" errorText="There was an issue processing this note." />}
        <DocumentActionPromptBanner
            title={title}
            description={description}
            templateType={TemplateType.MEDICAL}
            template={template}
            setTemplate={setTemplate}
            templateIdForce={selectedNoteMetadata?.template_id}
            buttonText={buttonText}
            onButtonClick={() => processNotes(true, selectedNoteMetadata?.id)}
            className="mb-3"
        />
    </div>
};